import jQuery from 'jquery';

export default class Lightbox {
    constructor(lightboxConfig) {
        const defaultConfig = {
            active: false,
            activeClass: 'RC-predictor_active',
            containerSelector: '.js-RC-predictor',
            overlaySelector: '.js-RC-predictor__overlay',
            closeBtnSelector: '.js-RC-predictor__closeBtn',
            openBtnsSelector: '.js-RC-predictor__openBtn',
            onOpen: null,
            onClose: null,
            onResize: null,
            onInit: null
        };
        this.config = jQuery.extend(true, defaultConfig, lightboxConfig);
        this.init();
    }

    init() {
        this.HTMLContainer = document.querySelector(this.config.containerSelector);
        this.HTMLCloseBtn = document.querySelector(this.config.closeBtnSelector);
        this.HTMLOpenBtns = document.querySelectorAll(this.config.openBtnsSelector);
        if (!this.HTMLContainer) {
            return;
        }
        this.active = this.config.active;
        if (this.active) {
            this.HTMLContainer.classList.add(this.config.activeClass);
        }
        this.bindEvents();
        this.storage = {}; // store custom data for caching as example
        if (this.config.onInit instanceof Function) {
            this.config.onInit(this);
        }
    }

    bindEvents() {
        if (this.HTMLCloseBtn) {
            this.HTMLCloseBtn.addEventListener('click', this.close.bind(this), false);
        }

        function openLightbox() {
            this.open();
        }

        if (this.HTMLOpenBtns.length) {
            for (let i = 0; i < this.HTMLOpenBtns.length; i += 1) {
                this.HTMLOpenBtns[i].addEventListener('click', openLightbox.bind(this), false);
            }
        }
        window.addEventListener('resize', this.onResize.bind(this));
    }

    open() {
        this.active = true;
        this.HTMLContainer.classList.add(this.config.activeClass);
        if (this.config.onOpen instanceof Function) {
            this.config.onOpen(this);
        }
    }

    close() {
        this.active = false;
        this.HTMLContainer.classList.remove(this.config.activeClass);
        if (this.config.onClose instanceof Function) {
            this.config.onClose(this);
        }
    }

    onResize() {
        if (this.active && this.config.onResize) {
            this.config.onResize(this);
        }
    }
}



// WEBPACK FOOTER //
// ./lib/js/modules/lightbox/lightbox.js